import { useState, Fragment } from 'react'
import { GridItem } from '@entur/grid'
import { StopPlacesDropdown } from '../components/ticket-rights/stop-places/stop-places-dropdown'

const stationPairElements = (
  key: number,
  fromStationChange: (e: string) => void,
  toStationChange: (e: string) => void
) => {
  return (
    <Fragment key={key}>
      <GridItem small={6}>
        <StopPlacesDropdown label="Fra stasjon" onChange={fromStationChange} />
      </GridItem>
      <GridItem small={6}>
        <StopPlacesDropdown label="Til stasjon" onChange={toStationChange} />
      </GridItem>
    </Fragment>
  )
}

type SelectedStationPair = {
  fromStation?: string
  toStation?: string
}

export const useStationPairs = () => {
  const [stationPairs, setStationPairs] = useState<Array<SelectedStationPair>>([
    { fromStation: undefined, toStation: undefined },
  ])

  const addStationPairs = () => {
    const newValues = { fromStation: undefined, toStation: undefined }
    setStationPairs(stationPairs.concat([newValues]))
  }

  const updatePair = (index: number, fromStation?: string, toStation?: string) => {
    stationPairs[index] = {
      ...stationPairs[index],
      fromStation: fromStation || stationPairs[index].fromStation,
      toStation: toStation || stationPairs[index].toStation,
    }
    setStationPairs([...stationPairs])
  }

  const elements = stationPairs.map((it, index) => {
    return {
      element: stationPairElements(
        index,
        (e) => updatePair(index, e),
        (e) => updatePair(index, undefined, e)
      ),
      fromStation: it.fromStation,
      toStation: it.toStation,
    }
  })

  return {
    stationPairs: elements,
    addStationPairs,
  }
}
